
//FUNCTION TO SELECT END OF TRANSITION

var whichTransitionEvent = function () {
    var t;
    var el = document.createElement('fakeelement');
    var transitions = {
        'transition': 'transitionend',
        'OTransition': 'oTransitionEnd',
        'MozTransition': 'transitionend',
        'WebkitTransition': 'webkitTransitionEnd'
    };

    for (t in transitions) {
        if (el.style[t] !== undefined) {
            return transitions[t];
        }
    }
};

//INIT YOUTUBE PLAYER

var player;
function onYouTubeIframeAPIReady() {
    var target = document.querySelector('.news-yt-video .yt');
    player = new YT.Player(target, {
        // height: '390',
        // width: '100%',
        videoId: target.dataset.video,
        playerVars: {
            controls: 0,
            disablekb: 1,
            enablejsapi: 1,
            iv_load_policy: 3,
            modestbranding: 1,
            rel: 0,
            showinfo: 0,
        },
        events: {
            // 'onReady': onPlayerReady,
            // 'onStateChange': onPlayerStateChange
        }
    });
}

//SET COOKIE

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

//GET COOKIE

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function purchageDatepickerDate() {
    $('.package-purchase-form form').find('input[name="member_activation_date"]').datepicker('setDate', new Date()).datepicker('hide');
}

$.fn.datepicker.languages['lt-LT'] = {
    format: 'yyyy-mm-dd',
    days: ['Sekmadienis', 'Pirmadienis', 'Antradienis', 'Trečiadienis', 'Ketvirtadienis', 'Penktadienis', 'Šeštadienis'],
    daysShort: ['Sekm', 'Pirm', 'Antr', 'Treč', 'Ketv', 'Penkt', 'Šešt'],
    daysMin: ['Sk', 'Pr', 'An', 'Tr', 'Kt', 'Pn', 'Št'],
    weekStart: 1,
    months: ['Sausis', 'Vasaris', 'Kovas', 'Balandis', 'Gegužė', 'Birželis', 'Liepa', 'Rugpjūtis', 'Rugsėjis', 'Spalis', 'Lapkritis', 'Gruodis'],
    monthsShort: ['Sau', 'Vas', 'Kov', 'Bal', 'Geg', 'Bir', 'Lie', 'Rgp', 'Rgs', 'Spa', 'Lap', 'Gru']
};

//VARS
var isMS = navigator.userAgent.indexOf('MSIE') != -1 || !!navigator.userAgent.match(/Trident.*rv\:11\./) || navigator.userAgent.indexOf('Edge') != -1,
    isIE = navigator.userAgent.indexOf('MSIE') != -1 || !!navigator.userAgent.match(/Trident.*rv\:11\./),
    isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
    isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1,
    transitionEvent = whichTransitionEvent(),
    lastY = 0;

//STUDIO SLICK VARS

var studioCarousel = $('.studio .studio-select-carousel'),
    studioSelector = $('.studio .studio-select .select-item'),
    studioSlickArgs = {
        'accessibility': false,
        'arrows': false,
        'draggable': false,
        'infinite': false,
        'swipe': false,
        'touchMove': false,
        'autoplay': true,
        'responsive': [
            {
                breakpoint: 992,
                settings: "unslick"
            }
        ]
    };

//SERVICES SLICK VARS

var serviceCarousel = $('.services .service-select-carousel'),
    serviceSelector = $('.services .service-select .select-item'),
    serviceSlickArgs = {
        'accessibility': false,
        'arrows': false,
        'draggable': false,
        'infinite': false,
        'swipe': false,
        'touchMove': false,
        // 'autoplay': true,
        'responsive': [
            {
                breakpoint: 992,
                settings: "unslick"
            }
        ]
    };

//TRAINING VARS

var trainingGrid = $('.training .training-cards'),
    trainingSelect = $('.training .training-selector-dropdown');

var coachesGrid = $('.coaches .coaches-cards'),
    coachesSelect = $('.coaches .training-selector-dropdown');